import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const AdminNavbar = () => {
  const navigate = useNavigate();
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const logoutUser = (event) => {
    localStorage.removeItem("strutspos_access_token");
    localStorage.removeItem("strutspos_user_id");
    navigate("/");
  };

  return (
    <nav className="modern-admin-navbar">
      <div className="admin-navbar-container">
        {/* Logo Section */}
        <div className="admin-navbar-brand">
          <Link to="/dashboard" className="admin-brand-link">
            <img
              src="/assets/logo.png"
              alt="Optimus"
              className="admin-brand-logo"
            />
            <span className="admin-brand-text">Optimus</span>
          </Link>
        </div>

        {/* Right Section - User Menu */}
        <div className="admin-navbar-right">
          <div className="admin-user-menu">
            <button
              className="admin-user-button"
              onClick={() => setUserMenuOpen(!userMenuOpen)}
            >
              <div className="admin-user-avatar">
                <span>👤</span>
              </div>
              <span className="admin-user-name">Admin</span>
              <span className="admin-dropdown-arrow">▼</span>
            </button>

            {userMenuOpen && (
              <div className="admin-user-dropdown">
                <Link to="/profile" className="admin-dropdown-item">
                  <span className="dropdown-icon">👤</span>
                  Profile
                </Link>
                {/* <Link to="/settings" className="admin-dropdown-item">
                  <span className="dropdown-icon">⚙️</span>
                  Settings
                </Link> */}
                <hr className="dropdown-divider" />
                <button
                  onClick={logoutUser}
                  className="admin-dropdown-item logout"
                >
                  <span className="dropdown-icon">🚪</span>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;
